import React, { useState, useEffect, useReducer } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg';
import { FaTimes } from 'react-icons/fa';
import { ReactComponent as ImageAddIcon } from '../../assets/svg/ImageAddIcon.svg';
import { ReactComponent as Save } from '../../assets/svg/Save.svg';
import '../../styles/modals/StudentInfoModal.css';
import { Controller, useForm } from 'react-hook-form';
import Loading from '../Loading';
import { useUser } from '../../auth/UseUser';
import MDEditor from '@uiw/react-md-editor';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import SingleQuestion from './SingleQuestion';
import { createNewDay, uploadFile } from '../../server/server';
import { fileSystemUrl } from '../../server/connections';
import { checkAllowedExtensions } from '../../utils/util';

function CreateDayContentModal({ modalIsOpen, closeModal, content = {}, index, course, reloadDay }: { modalIsOpen: any; closeModal: any; content: any; index: any; course: any; reloadDay: any }) {
	const { user, setUser } = useUser();

	const [image, setImage] = useState<string | undefined>(undefined);
	const [iconId, setIconId] = useState('');
	const [selectedFile, setSelectedFile] = useState(undefined);

	const [picture, setPicture] = useState<string | undefined>(undefined);
	const [pictureId, setPictureId] = useState('');
	const [selectedPictureFile, setSelectedPictureFile] = useState(undefined);

	const [audio, setAudio] = useState<string | undefined>(undefined);
	const [audioId, setAudioId] = useState('');
	const [selectedAudioFile, setSelectedAudioFile] = useState(undefined);

	const [processing, setProcessing] = useState(false);
	const [questionsTitleError, setQuestionsTitleError] = useState(false);
	const [optionsTitleError, setOptionsTitleError] = useState(false);
	const [sameOptionsError, setSameOptionsError] = useState(false);
	const [showErrorMessage, setShowErrorMessage] = useState(false);
	const DEFAULT_QUESTION = {
		text: '',
		order: 1,
		answers: [
			{
				text: '',
				order: 1,
			},
			{
				text: '',
				order: 2,
			},
		],
	};
	const [questions, setQuestions] = useState([DEFAULT_QUESTION]);

	const { register, handleSubmit, reset, formState, getValues, setValue, control } = useForm({
		defaultValues: {
			title: '',
			wisdomTitle: '',
			wisdomText: '',
			text: '',
			challenge: '',
			audioTitle: '',
			reflectionQuestion: '',
			challengeTitle: '',
		},
	});
	const { isDirty, isValid, errors } = formState;

	useEffect(() => {
		const element = document.getElementById('home');
		if (modalIsOpen) {
			ReactModal.setAppElement('#root');
			if (!!element) element.style.filter = 'blur(5px)';
		} else {
			if (!!element) element.style.filter = 'unset';
		}
	}, [modalIsOpen]);

	useEffect(() => {
		if (modalIsOpen && !!content?.id) {
			setValue('title', content.title);
			setValue('wisdomTitle', content.wisdomTitle);
			setValue('wisdomText', content.wisdomText);
			setValue('text', content.text);
			setValue('challenge', content.challenge);
			setValue('audioTitle', content.audioTitle);
			setValue('reflectionQuestion', content.reflectionQuestion);
			setValue('challengeTitle', content.challengeTitle);
			let sortedList = content.questions?.map((element: any) => {
				element.answers = [...element.possibleAnswers];
				element.correctAnswerIndex = element.answers.findIndex((e: any) => e.text === element.correctAnswer.text);
				return element;
			});

			setQuestions(sortedList);
			if (!!content?.icon) {
				setImage(fileSystemUrl + '/' + content.icon?.url);
				setIconId(content.icon.id);
			}
			if (!!content?.picture) {
				setPicture(fileSystemUrl + '/' + content.picture?.url);
				setPictureId(content.picture.id);
			}
			if (!!content?.audio) {
				setAudio(fileSystemUrl + '/' + content.audio?.url);
				setAudioId(content.audio.id);
			}
		}
	}, [modalIsOpen]);

	useEffect(() => {
		if (!selectedFile) {
			setImage(undefined);
			return;
		}
		console.log('set img');
		const objectUrl = URL.createObjectURL(selectedFile);
		setImage(objectUrl);
	}, [selectedFile]);

	useEffect(() => {
		if (!selectedPictureFile) {
			setPicture(undefined);
			return;
		}
		console.log('set img');
		const objectUrl = URL.createObjectURL(selectedPictureFile);
		setPicture(objectUrl);
	}, [selectedPictureFile]);

	useEffect(() => {
		if (!selectedAudioFile) {
			setAudio(undefined);
			return;
		}
		console.log('set img');
		const objectUrl = URL.createObjectURL(selectedAudioFile);
		setAudio(objectUrl);
	}, [selectedAudioFile]);

	const handleAddQuestion = () => {
		setQuestions([
			...questions,
			{
				text: '',
				order: questions.length + 1,
				answers: [
					{
						text: '',
						order: 0,
					},
					{
						text: '',
						order: 1,
					},
				],
			},
		]);
	};

	const onSubmit = async () => {
		if (!validate()) return;
		let newDay: any = getValues();
		newDay.courseId = course?.id;
		newDay.order = index + 1;
		if (iconId) newDay.iconId = iconId;
		if (pictureId) newDay.pictureId = pictureId;
		if (audioId) {
			newDay.audioId = audioId;
		} else {
			newDay.audioId = null;
			newDay.audioTitle = '';
		}
		let newList = JSON.parse(JSON.stringify(questions));
		newList = newList?.map((item: any, index: number) => {
			item.possibleAnswers = [];
			item.correctAnswer = {};
			if (!item.correctAnswerIndex) item.correctAnswerIndex = 0;
			const correctAnswer = item.answers[item.correctAnswerIndex];
			item.possibleAnswers = item.answers;
			item.correctAnswer = correctAnswer;
			// item.answers?.map((answer: any, index: number) => {
			// 	if (item.correctAnswerIndex === index) {
			// 		item.correctAnswer = answer;
			// 	} else {
			// 		item.possibleAnswers.push(answer);
			// }
			// });

			delete item.correctAnswerIndex;
			delete item.answers;
			delete item.deletedAt;
			delete item.id;
			delete item.correctAnswer.deletedAt;
			delete item.correctAnswer.id;
			item.possibleAnswers = item.possibleAnswers?.map((answer: any) => {
				delete answer.deletedAt;
				delete answer.id;
				return answer;
			});
			return item;
		});
		newDay.questions = newList;
		console.log('day form data ', newDay, questions);
		if (!content?.id) {
			createDay(newDay);
		} else {
			updateDay(newDay);
		}
	};

	const createDay = async (newDay: any) => {
		setProcessing(true);
		const resp = await createNewDay(newDay);
		if (resp.status === 201) {
			reloadDay(resp.data?.id);
			closeModal();
			setProcessing(false);
		} else {
			setProcessing(false);
		}
	};

	const updateDay = async (newDay: any) => {
		newDay.id = content?.id;
		setProcessing(true);
		const resp = await createNewDay(newDay);
		if (resp.status === 201) {
			reloadDay(resp.data?.id);
			closeModal();
			setProcessing(false);
		} else {
			setProcessing(false);
		}
	};

	const press_upload = () => {
		document.getElementById('photo_upload_modal')?.click();
	};

	const press_icon_upload = () => {
		document.getElementById('icon_upload_modal')?.click();
	};

	const press_upload_audio = () => {
		document.getElementById('audio_upload_modal')?.click();
	};

	const closeImage = () => {
		setImage(undefined);
		setSelectedFile(undefined);
		setIconId('');
	};
	const closePicture = () => {
		setPicture(undefined);
		setSelectedPictureFile(undefined);
		setPictureId('');
	};
	const closeAudio = () => {
		setAudio(undefined);
		setSelectedAudioFile(undefined);
		setAudioId('');
	};

	const onImageChange = async (e: any) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(undefined);
			return;
		}
		let file = e.target.files[0];
		if (file.size > 15728640) {
			alert('File is too big!');
			setSelectedFile(undefined);
			return;
		}
		if (!checkAllowedExtensions(file.name)) {
			alert('Type of file is not allowed!');
			return;
		}
		const resp = await uploadFile({ file: file });
		if (resp.status == 201) {
			const uploadedImage = resp.data;
			setIconId(uploadedImage.id);
		} else {
			return;
		}
		console.log('Selected file : ', file);
		setSelectedFile(file);
	};
	const onPictureChange = async (e: any) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedPictureFile(undefined);
			return;
		}
		let file = e.target.files[0];
		if (file.size > 15728640) {
			alert('File is too big!');
			setSelectedPictureFile(undefined);
			return;
		}
		if (!checkAllowedExtensions(file.name)) {
			alert('Type of file is not allowed!');
			return;
		}
		const resp = await uploadFile({ file: file });
		if (resp.status == 201) {
			const uploadedImage = resp.data;
			setPictureId(uploadedImage.id);
		} else {
			return;
		}
		console.log('Selected file : ', file);
		setSelectedPictureFile(file);
	};
	const onAudioChange = async (e: any) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedAudioFile(undefined);
			return;
		}
		let file = e.target.files[0];
		if (file.size > 15728640) {
			alert('File is too big!');
			setSelectedAudioFile(undefined);
			return;
		}
		const resp = await uploadFile({ file: file });
		if (resp.status == 201) {
			const uploadedImage = resp.data;
			setAudioId(uploadedImage.id);
		} else {
			return;
		}
		console.log('Selected audio file : ', file);
		setSelectedAudioFile(file);
	};
	const resetInputValue = (e: any) => {
		e.target.value = null;
	};
	const resetPictureInputValue = (e: any) => {
		e.target.value = null;
	};
	const resetAudioInputValue = (e: any) => {
		e.target.value = null;
	};

	// Function to update list on drop
	const handleDrop = (droppedItem: any) => {
		// Ignore drop outside droppable container
		if (!droppedItem.destination) return;
		var updatedList = [...questions];
		// Remove dragged item
		const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
		// Add dropped item
		updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
		// Update State
		let newReorderList = updatedList.map((item, index) => {
			return { ...item, order: index + 1 };
		});
		setQuestions(newReorderList);
		//document.getElementById('saveChanges')?.click();
	};

	const resetModal = () => {
		reset();
		setImage(undefined);
		setSelectedFile(undefined);
		setIconId('');
		setPicture(undefined);
		setSelectedPictureFile(undefined);
		setPictureId('');
		setAudio(undefined);
		setSelectedAudioFile(undefined);
		setAudioId('');
		setQuestions([DEFAULT_QUESTION]);
		setQuestionsTitleError(false);
		setOptionsTitleError(false);
		setSameOptionsError(false);
		setShowErrorMessage(false);
	};

	const validate = () => {
		let valid = true;
		questions.forEach((element: any) => {
			if (element.text === '') {
				setQuestionsTitleError(true);
				valid = false;
				return;
			}
		});
		questions.forEach((question) => {
			if (checkIfDuplicateExists(question.answers)) {
				setSameOptionsError(true);
				valid = false;
			}
			question.answers.forEach((option: any) => {
				if (option?.text === '') {
					setOptionsTitleError(true);
					valid = false;
					return;
				}
			});
		});
		//setShowErrorMessage(!valid);
		return valid;
	};

	const checkIfDuplicateExists = (arr: any) => {
		var newList = arr.map((item: any) => {
			return item.text;
		});
		return new Set(newList).size !== newList.length;
	};

	return (
		<ReactModal
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => resetModal()}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 0,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 900,
					margin: 'auto',
					backgroundColor: 'transparent',
					maxHeight: '100vh',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'scrollbar-display-none'}
		>
			<div className='student-info-modal  '>
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<div className='close-modal-icon ' onClick={() => closeModal()}>
						<CloseModalIcon />
					</div>
				</div>

				<form onSubmit={handleSubmit(onSubmit)} className='bg-white rounded-xl mx-3 flex-1 flex flex-col gap-5 px-[40px] py-[30px] '>
					<div className='flex flex-row items-center justify-between'>
						<div className='flex-1'>
							<p className='text-primaryViolet font-semibold text-3xl text-left'>{!content?.wisdomTitle ? 'Create day content' : 'Edit day content'}</p>
						</div>
					</div>
					<div>
						<div className='w-full'>
							<p className='text-primaryViolet text-[16px] leading-5 font-semibold text-left'>Title</p>
							<div className={`border-b   p-2 mt-2 flex flex-row items-center ${errors.title?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
								<input className={`w-full text-[16px] leading-5 font-semibold text-primaryViolet ${errors.title?.type === 'required' ? 'placeholder:text-redError' : ''}`} placeholder={`Type course title`} {...register('title', { required: true })} style={{ backgroundColor: 'transparent' }} />
								<p className='text-redError text-[16px] leading-5 font-semibold  text-nowrap'>{errors.title?.type === 'required' ? '*This field is required' : ''}</p>
							</div>
						</div>
						<div className='flex flex-row items-end justify-between gap-5'>
							<div className='flex flex-col justify-center items-center mt-5'>
								<p className='text-primaryViolet font-semibold text-lg text-left'>Course day picture</p>
								{!picture && (
									<div className='flex flex-col items-center justify-center bg-greyBackground rounded-xl py-8 w-[334px]'>
										<ImageAddIcon style={{ width: 42, height: 42, color: '#8484b1' }} />
										<p className='text-mudPurple text-[16px] leading-5 font-semibold text-center w-[160px]'>The maximum image size for download is 1400px x 1400px</p>
										<button
											className='text-primaryViolet rounded-full bg-lightBG py-1 text-[16px] leading-5 font-semibold px-5 mt-3'
											onClick={(e) => {
												e.preventDefault();
												press_upload();
											}}
										>
											Add Photo
										</button>
									</div>
								)}
								{picture && (
									<div className='flex relative max-h-[244px] flex-col items-center justify-center bg-greyBackground rounded-xl pt-12 pb-4 w-[334px]'>
										<div onClick={() => closePicture()} className='bg-white opacity-40 p-2 rounded-full cursor-pointer border border-greyLight absolute top-[8px] right-[8px] hover:border-greyMedium'>
											<FaTimes style={{ width: 20, height: 20, stroke: 'white', display: 'block' }} />
										</div>

										<img style={{ objectFit: 'contain', width: '100%', minHeight: 170 }} src={picture} alt='' />
									</div>
								)}
								<input title='Add Video/Photo' style={{ display: 'none' }} accept='image/*' type='file' id='photo_upload_modal' onChange={onPictureChange} onClick={resetPictureInputValue} />
							</div>
							<div className='flex flex-col justify-center items-center'>
								<p className='text-primaryViolet text-[16px] leading-5 font-semibold text-left'>Course day icon</p>
								{!image && (
									<div className='flex flex-col items-center justify-center bg-greyBackground rounded-xl py-8 w-[334px]'>
										<ImageAddIcon style={{ width: 42, height: 42, color: '#8484b1' }} />
										<p className='text-mudPurple text-[16px] leading-5 font-semibold text-center w-[160px]'>The maximum image size for download is 1400px x 1400px</p>
										<button
											className='text-primaryViolet rounded-full bg-lightBG py-1 text-[16px] leading-5 font-semibold px-5 mt-3'
											onClick={(e) => {
												e.preventDefault();
												press_icon_upload();
											}}
										>
											Add day icon
										</button>
									</div>
								)}
								{image && (
									<div className='flex relative max-h-[244px] flex-col items-center justify-center bg-greyBackground rounded-xl pt-12 pb-4 w-[334px]'>
										<div onClick={() => closeImage()} className='bg-white opacity-40 p-2 rounded-full cursor-pointer border border-greyLight absolute top-[8px] right-[8px] hover:border-greyMedium'>
											<FaTimes style={{ width: 20, height: 20, stroke: 'white', display: 'block' }} />
										</div>

										<img style={{ objectFit: 'contain', width: '100%', minHeight: 170 }} src={image} alt='' />
									</div>
								)}
								<input title='Add Video/Photo' style={{ display: 'none' }} accept='image/*' type='file' id='icon_upload_modal' onChange={onImageChange} onClick={resetInputValue} />
							</div>
						</div>

						<div className='mt-3'>
							<div className='flex flex-row items-end justify-between gap-5'>
								<p className={`text-primaryViolet font-semibold text-lg text-left ${errors.wisdomTitle?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}>Wisdom title</p>

								<p className='text-redError font-medium text-lg  '>{errors.wisdomTitle?.type === 'required' ? '* This field is required' : ''}</p>
							</div>
							<Controller control={control} name='wisdomTitle' rules={{ required: true }} render={({ field }) => <MDEditor data-color-mode='light' style={{ color: 'rgb(94,99,155)' }} value={field.value} onChange={(value: any) => setValue('wisdomTitle', value, { shouldValidate: true })} preview='edit' />} />
						</div>
						<div className='mt-4'>
							<div className='flex flex-row items-end justify-between gap-5'>
								<p className={`text-primaryViolet font-semibold text-lg text-left ${errors.wisdomText?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}>Wisdom text</p>

								<p className='text-redError font-medium text-lg  '>{errors.wisdomText?.type === 'required' ? '* This field is required' : ''}</p>
							</div>
							<Controller control={control} name='wisdomText' rules={{ required: true }} render={({ field }) => <MDEditor data-color-mode='light' style={{ color: 'rgb(94,99,155)' }} value={field.value} onChange={(value: any) => setValue('wisdomText', value, { shouldValidate: true })} preview='edit' />} />
						</div>
						<div className='mt-4'>
							<p className='text-primaryViolet font-semibold text-lg text-left'>Challenge Title</p>
							<div className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.challengeTitle?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
								<input className={`w-full text-primaryViolet ${errors.challengeTitle?.type === 'required' ? 'placeholder:text-redError' : ''}`} placeholder={`Type any additional text here`} {...register('challengeTitle', { required: true })} style={{ backgroundColor: 'transparent' }} />
								<p className='text-redError   text-nowrap'>{errors.challengeTitle?.type === 'required' ? '*This field is required' : ''}</p>
							</div>
						</div>
						<div className='mt-4'>
							<div className='flex flex-row items-end justify-between gap-5'>
								<p className={`text-primaryViolet font-semibold text-lg text-left ${errors.challenge?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}>Challenge</p>

								<p className='text-redError font-medium text-lg  '>{errors.challenge?.type === 'required' ? '* This field is required' : ''}</p>
							</div>
							<Controller control={control} name='challenge' rules={{ required: true }} render={({ field }) => <MDEditor data-color-mode='light' style={{ color: 'rgb(94,99,155)' }} value={field.value} onChange={(value: any) => setValue('challenge', value, { shouldValidate: true })} preview='edit' />} />
						</div>

						<div className='mt-4'>
							<div className='flex flex-row items-end justify-between gap-5'>
								<p className={`text-primaryViolet font-semibold text-lg text-left ${errors.text?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}>Text</p>

								<p className='text-redError font-medium text-lg  '>{errors.text?.type === 'required' ? '* This field is required' : ''}</p>
							</div>
							<Controller control={control} name='text' rules={{ required: true }} render={({ field }) => <MDEditor data-color-mode='light' style={{ color: 'rgb(94,99,155)' }} value={field.value} onChange={(value: any) => setValue('text', value, { shouldValidate: true })} preview='edit' />} />
						</div>

						<div className='mt-4'>
							<p className='text-primaryViolet font-semibold text-lg text-left'>Reflection</p>
							<div className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.reflectionQuestion?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
								<input className={`w-full text-primaryViolet ${errors.reflectionQuestion?.type === 'required' ? 'placeholder:text-redError' : ''}`} placeholder={`Type any additional text here`} {...register('reflectionQuestion', { required: true })} style={{ backgroundColor: 'transparent' }} />
								<p className='text-redError   text-nowrap'>{errors.reflectionQuestion?.type === 'required' ? '*This field is required' : ''}</p>
							</div>
						</div>

						<div className='mt-3'>
							<p className='text-primaryViolet font-semibold text-lg text-left'>Audio file title</p>
							<div className='border-b border-b-deselectPurple p-2 mt-2 '>
								<input className='w-full text-primaryViolet ' placeholder={`Audio file title`} {...register('audioTitle')} style={{ backgroundColor: 'transparent' }} />
							</div>
							<p className='text-redError text-[12px] leading-4 h-4 '>{errors.audioTitle?.type === 'required' ? 'This field is required' : ''}</p>
						</div>
						<div className='flex flex-col justify-center items-center mt-5'>
							{!audio && (
								<div className='flex flex-col items-center justify-center bg-greyBackground rounded-xl py-8 w-[334px]'>
									<ImageAddIcon style={{ width: 42, height: 42, color: '#8484b1' }} />
									<p className='text-mudPurple text-[16px] leading-5 font-semibold w-[160px] text-center'>
										Add audio file here. Accept only <i>.mp3</i>
									</p>
									<button
										className='text-primaryViolet rounded-full bg-lightBG py-1 text-[16px] leading-5 font-semibold px-5 mt-3'
										onClick={(e) => {
											e.preventDefault();
											press_upload_audio();
										}}
									>
										Add Audio
									</button>
								</div>
							)}
							{audio && (
								<div className='flex relative max-h-[244px] flex-col items-center justify-center bg-greyBackground rounded-xl pt-12 pb-4 w-[334px]'>
									<div onClick={() => closeAudio()} className='bg-white opacity-40 p-2 rounded-full cursor-pointer border border-greyLight absolute top-[8px] right-[8px] hover:border-greyMedium'>
										<FaTimes style={{ width: 20, height: 20, stroke: 'white', display: 'block' }} />
									</div>

									<audio controls>
										<source src={audio} type='audio/mp3' />
										Vaš pretraživač ne podržava reprodukciju zvuka.
									</audio>
								</div>
							)}
							<input title='Add Video/Photo' style={{ display: 'none' }} accept='audio/*' type='file' id='audio_upload_modal' onChange={onAudioChange} onClick={resetAudioInputValue} />
						</div>

						<div className='mt-3'>
							<p className='text-primaryViolet font-semibold text-lg text-left'>Quiz questions</p>
							<div className='mt-5'>
								<DragDropContext onDragEnd={handleDrop}>
									<Droppable droppableId='list-container'>
										{(provided) => (
											<div {...provided.droppableProps} ref={provided.innerRef}>
												{questions?.map((question, index) => {
													return (
														<Draggable key={index.toString()} draggableId={index.toString()} index={index}>
															{(provided) => (
																<div className='mb-5' ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
																	<SingleQuestion key={index} question={question} index={index} questions={questions} setQuestions={setQuestions} questionsTitleError={questionsTitleError} optionsTitleError={optionsTitleError} sameOptionsError={sameOptionsError} />
																</div>
															)}
														</Draggable>
													);
												})}
												{provided.placeholder}
												<div className='pointer my-5 flex w-full items-center justify-center rounded-xl  bg-mudPurple py-4 text-base font-semibold text-white hover:bg-deepPurple' onClick={() => handleAddQuestion()}>
													Add question {questions.length + 1}
												</div>
											</div>
										)}
									</Droppable>
								</DragDropContext>
							</div>
						</div>
						{/* <div className='mt-2'>
							<p className={`text-center text-[14px] font-medium text-[#FF747F] ${showErrorMessage ? '' : 'opacity-0'}`}>* Please select correct answer!</p>
						</div> */}
					</div>
					<div className='flex flex-row justify-end w-full gap-5'>
						{/* <div
							className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer rounded-full bg-[#fafaff]  h-[60px] button-transparent-class'
							onClick={closeModal}
						>
							<p className='text-[18px] text-darkenPurple leading-5 font-semibold mr-3 '>Back</p>
						</div> */}
						<button className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer  rounded-full bg-primaryViolet  min-h-[60px] button-save-class transition' disabled={processing}>
							{processing ? (
								<Loading primaryColor='#FDDF6D' secondaryColor='#5E639B' size={25} stroke={7} />
							) : (
								<div className='flex flex-row items-center justify-center'>
									<p className='text-[18px]  leading-5 font-semibold mr-3 '>Save</p>
									<Save />
								</div>
							)}
						</button>
					</div>
				</form>
			</div>
		</ReactModal>
	);
}

export default CreateDayContentModal;
